import csrfToken from './csrf-token';
import { translate } from './localisations';

const $ = window.$ || window.jQuery;

class Form {

  constructor($form) {
    $form.attr('novalidate', 'novalidate');
    $form.attr('data-ajax-form-state', 'waiting');

    // Initialize js components
    const $birthday = $form.find('#birthday');
    if ($birthday.length > 0) {
      $birthday.datepicker({
        dateFormat: 'dd.mm.yy',
        constrainInput: true,
        showOn: 'both',
        buttonImageOnly: true,
        buttonImage: $birthday.data('calendar-icon'),
        buttonText: $birthday.data('calendar-text'),
        changeMonth: true,
        changeYear: true,
        yearRange: $birthday.data('min-year') + ':' + $birthday.data('max-year')
      });

      if ($.datepicker.regional[document.documentElement.lang]) {
        $birthday.datepicker($.datepicker.regional[document.documentElement.lang]);
      }
    }

    // Initialize listeners
    $form.on('change value keyup', '.error', function(){
      const $input = $(this);
      if ($input.val()) {
        $input.removeClass('error');
        $input.parent().find('.ajax-form__field-error').remove();
      }
    });
    $form.on('submit', () => {
      this.submit();
      return false;
    });

    this.$form = $form;
    this.validationResult = null;
  }

  /**
   * Validates form fields. If validation fails, errors can be accessed in this.validationResult object.
   *
   * @param {FormData} data Form data to validate.
   * @return {Boolean} True if validation is successful.
   */
  validate(data) {
    const validationResult = {
      message: '',
      fields: {},
    };

    const items = data.entries();
    for (let i = 0; i < items.length; i++) {
      const name = items[i][0];
      const value = items[i][1];
      const $input = this.$form.find('[name="' + name + '"]');
      if ($input.attr('type') === 'file' && value && value.size) {
        const size = parseInt($input.data('max-size')) || false;
        if (size && value.size > size) {
          validationResult.fields[name] = translate('form__error__file_size');
        }
      }
    }

    const hasError = Object.keys(validationResult.fields).length > 0 || validationResult.message;
    this.validationResult = hasError ? validationResult : null;
    return !hasError;
  }

  /**
   * Submits form to server if there is no ongoing submission and if it passes validation.
   */
  submit() {
    if (this.$form.attr('data-ajax-form-state') === 'sending') {
      return;
    }

    const data = new FormData(this.$form[0]);
    data.set('token', csrfToken.getToken());

    if (!this.validate(data)) {
      this._hideErrors();
      this._showErrors(this.validationResult);
      return;
    }

    this._hideErrors();
    this.$form.attr('data-ajax-form-state', 'sending');
    const $submit = this.$form.find('[type="submit"]');
    $submit.find('.teksti').text($submit.data('text-sending'));


    $.ajax({
      url: '/stage-ajax/forms/?stage-language=' + document.documentElement.lang,
      data: data,
      type: 'POST',
      contentType: false,
      processData: false
    }).always((response) => {
      $submit.find('.teksti').text($submit.data('text'));



      if (response && response.success) {
        window.dataLayer = window.dataLayer ? window.dataLayer : [];
        const formType = new FormData(this.$form[0]).get('form');
        window.dataLayer.push({
          'event': formType+'FormSuccess'
        });

        this.$form.attr('data-ajax-form-state', 'success');
        this.$form.replaceWith(response.html);

        $('html, body').animate({
          scrollTop: $('.form-result').offset().top - 30
        }, 400);

        csrfToken.updateToken(response.token);
      }
      else {
        this.$form.attr('data-ajax-form-state', 'waiting');
        this._showErrors(response.errors);
      }
    });
  }

  /**
   * Remove error classes from fields and remove error messages.
   */
  _hideErrors() {
    this.$form.find('.ajax-form__form-error').remove();
    this.$form.find('.ajax-form__field-error').remove();
    this.$form.find('input, select, textarea').removeClass('error');
  }

  /**
   * Shows error messages and adds error classes to invalid fields.
   *
   * @param {Object} errors Error message and invalid fields.
   * @param {String} [errors.message] Form error message.
   * @param {Object} [errors.fields] Invalid field names and error messages.
   */
  _showErrors(errors) {
    if (typeof errors !== 'object') {
      return;
    }

    if (errors.message) {
      this.$form.prepend(`<div class="ajax-form__form-error">${errors.message}</div>`);
    }

    if (errors.fields) {
      for (let field in errors.fields) {
        const $input = this.$form.find('[name="' + field + '"]').filter(':not([type="hidden"])').addClass('error');
        $input.parent().append(`<div class="ajax-form__field-error">${errors.fields[field]}</div>`);
      }
    }

    $('html, body').animate({
      scrollTop: this.$form.offset().top - 30
    }, 400);
  }

}

export default Form;
